import React, { useContext } from 'react';
import type { NodeToRenderProps, CustomNode } from '@src/components/custom-nodes/types';
import { ReactflowInstanceContext } from '@src/scenario-editor/ScenarioEditor';
import { reactFlowInstanceAtom } from '@src/atoms';

export const withCustomNodeData = (WrappedComponent: React.FC<NodeToRenderProps>) => {
  return function FixedWidthWrapper(props: NodeToRenderProps) {
    const reactFlowInstance = useContext(ReactflowInstanceContext).get(reactFlowInstanceAtom)!;
    const customNodeData = reactFlowInstance?.getNodes().find(node => node.id === props.id);
   return (
      <WrappedComponent
        {...props}
        customNodeData={customNodeData as CustomNode}
        >
        {props.children}
      </WrappedComponent>
    );
  };
}
